import CypherService from '../../services/cypher-services';
import { ARCADE_PROJECT_STENCIL, ROOM_NAME_KEY } from '../../utils/constants';

export const fetchRoomNames = async ( { rooms, user, locale, lastRequestKey } ) => {
    if ( !Array.isArray( rooms ) || rooms.length === 0 || !user || !locale ) {
        return null;
    }

    const roomIds = [ ...new Set(
        rooms
            .filter( ( room ) => room.tokens > 0 )
            .map( ( room ) => room.id )
    ) ];

    if ( roomIds.length === 0 ) {
        return null;
    }

    const requestKey = `${ locale }::${ [ ...roomIds ].sort().join( ',' ) }`;
    if ( requestKey === lastRequestKey ) {
        return null;
    }

    const cypher = CypherService( user );
    const result = await cypher.getStencilInstancesByCodesAndLocales(
        ARCADE_PROJECT_STENCIL,
        locale,
        roomIds,
    );

    const roomNamesMap = Object.entries( result.stencils || {} ).reduce(
        ( acc, [ roomId, roomData ] ) => {
            acc[ roomId ] = roomData?.[ locale ]?.[ ROOM_NAME_KEY ] || '';
            return acc;
        },
        {}
    );

    return {
        requestKey,
        roomNamesMap,
    };
};